import GoogleCaptcha from './GoogleCaptcha';

export default GoogleCaptcha;
